// src/app/components/ColorFilterTrendChart/ColorFilterTrendChart.tsx
import React from "react";
import { Box, Text } from "@mantine/core";
import { AgCharts } from "ag-charts-react";

import { useAppSelector } from "../../app/hooks";
import { selectTrendByKeyArgsForColorFilter } from "../../globalSelectors";
import { skipToken } from "@reduxjs/toolkit/query";
import { usePostMultiplacerRoomSnapshotTrendByKeyQuery } from "../../../openapi";
import { selectColorFilterTrendChart } from "../../Room/colorFilterTrendSelectors";

export const ColorFilterTrendChart: React.FC = () => {
  const args = useAppSelector(selectTrendByKeyArgsForColorFilter);

  // ✅ switched from mcbim -> multiplacer roomSnapshots
  const { isLoading, isError, error } = usePostMultiplacerRoomSnapshotTrendByKeyQuery(
    args ?? skipToken
  );

  const { options, isEmpty } = useAppSelector(selectColorFilterTrendChart);

  if (isEmpty)
    return (
      <Text size="sm" c="dimmed">
        Ingen data for valgt filter.
      </Text>
    );

  if (isLoading) {
    return (
      <Box>
        <Text size="sm" c="dimmed">
          Laster trend…
        </Text>
      </Box>
    );
  }

  if (isError) {
    return (
      <Box>
        <Text size="sm" c="red">
          Klarte ikke å laste trend.
        </Text>
        <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>{JSON.stringify(error, null, 2)}</pre>
      </Box>
    );
  }

  return (
    <Box>
      <AgCharts options={options} />
    </Box>
  );
};
